import React, { useCallback } from 'react';
import { DomainObject, TextField, Tooltip } from '@eas/common-web';
import { useStyles } from '../ks-public-form-select-styles';
import MuiChip from '@material-ui/core/Chip';

export function useKsPublicSelectRenderFunction() {
  const { chips, chip, renderer } = useStyles();

  const renderFunc = useCallback(
    <OPTION extends DomainObject>(
      val: any,
      multiple: boolean,
      options: OPTION[],
      labelMapper: (option: OPTION) => string = (option) =>
        (option as any).name,
      Component: React.ElementType = TextField
    ) => {
      if (multiple) {
        const ids = val as string[];
        const selectedOptions = ids
          .map((id) => options.find((option) => option.id === id))
          .filter((option): option is OPTION => option !== undefined);

        if (selectedOptions.length === 0) {
          return <Component disabled value="" />;
        }

        return (
          <div className={chips}>
            {selectedOptions.map((option) => {
              if (!option) return null;

              return (
                <MuiChip
                  key={option.id}
                  variant="outlined"
                  size="small"
                  className={chip}
                  label={
                    <Tooltip placement="top-start" title={labelMapper(option)}>
                      <span>{labelMapper(option)}</span>
                    </Tooltip>
                  }
                />
              );
            })}
          </div>
        );
      } else {
        const id = val as string;
        const option = options.find((option) => option.id === id);
        const label = option ? labelMapper(option) : '';

        return <div className={renderer}>{label}</div>;
      }
    },
    [chip, chips, renderer]
  );

  return renderFunc;
}
